import { render, staticRenderFns } from "./quickTrade.vue?vue&type=template&id=5509b870"
import script from "./quickTrade.vue?vue&type=script&lang=js"
export * from "./quickTrade.vue?vue&type=script&lang=js"
import style0 from "./quickTrade.vue?vue&type=style&index=0&id=5509b870&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports